import {
  searchQuickListSettingsService,
  getQuickListSettingService,
  saveQuickListSettingService,
  deleteQuickListSettingService,
  searchAdminProductsService,
} from 'redux/services/quickListSettingsServices'

export const searchQuickListSettingsAction = payload => async () => {
  const response = await searchQuickListSettingsService(payload)
  const { data, status } = response
  if (status === 200 && data?.Data) {
    return data.Data
  }
  return []
}

export const getQuickListSettingAction = productCustomListId => async () => {
  const response = await getQuickListSettingService(productCustomListId)
  const { data, status } = response
  if (status === 200 && data?.Data?.length > 0) {
    return data.Data[0]
  }
  return null
}

export const saveQuickListSettingAction = payload => async () => {
  const response = await saveQuickListSettingService(payload)
  const { data, status } = response
  return status === 200 && data?.Status?.Code === 200
}

export const deleteQuickListSettingAction = productCustomListId => async () => {
  const response = await deleteQuickListSettingService(productCustomListId)
  const { data, status } = response
  return status === 200 && data?.Status?.Code === 200
}

export const searchAdminProductsAction = payload => async () => {
  const response = await searchAdminProductsService(payload)
  const { data, status } = response
  if (status === 200 && data?.Data) {
    return data.Data
  }
  return []
}
